import { usePubblicaAvviso } from "@/contexts/AvvisiContext";

// Sprint UI-GLOBALE — regola unica: l'avviso resta in pagina solo se IN QUEL PUNTO e PER QUELL'UTENTE
// c'è un comando da premere (`conAzione`); altrimenti va nel centro avvisi, con `link` al punto
// in cui il comando esiste (se esiste).
export default function AvvisoPagina({ id, conAzione = false, livello = "info", testo, link = null, children }) {
  usePubblicaAvviso(id, { attivo: !conAzione, livello, testo, link });
  return conAzione ? children : null;
}
